<script setup lang="ts">
const { denyAll, preferences, categoryMeta, updatePreferences } =
  useCookieConsent()

const open = ref(false)

const localPrefs = reactive<Record<string, boolean | null>>({})

watchEffect(() => {
  if (open.value && preferences.value && Object.keys(preferences).length) {
    for (const key in preferences.value) {
      localPrefs[key] = preferences.value[key] ?? true
    }
  }
})

function savePreferences() {
  updatePreferences(localPrefs)
  open.value = false
}

function handleDeny() {
  denyAll()
  open.value = false
}
</script>

<template>
  <UModal v-model:open="open" title="Cookie Preferences">
    <UButton variant="outline" block class="text-nowrap"> Customize </UButton>

    <template #body>
      <div
        v-for="(meta, key) in categoryMeta"
        :key="key"
        class="mb-6 flex items-start justify-between"
      >
        <div>
          <p class="font-medium">
            {{ meta.label }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ meta.description }}
          </p>
        </div>

        <USwitch
          unchecked-icon="i-lucide-x"
          checked-icon="i-lucide-check"
          v-model="localPrefs[key] as boolean | undefined"
          :disabled="meta.required"
        />
      </div>
    </template>

    <template #footer="{ close }">
      <UButton
        label="Deny All"
        color="neutral"
        variant="outline"
        @click="handleDeny"
      />

      <div class="flex items-center justify-end w-full gap-4">
        <UButton
          label="Cancel"
          color="neutral"
          variant="outline"
          @click="close"
        />

        <UButton
          label="Save"
          color="neutral"
          @click="savePreferences"
          class="px-6"
        />
      </div>
    </template>
  </UModal>
</template>
